import { ExhibitionKioskRedirect } from '@/components/ExhibitionKioskRedirect';
import { SidebarStateProvider } from '@/components/ui/sidebar';

export function AppShellLayout() {
  return (
    <SidebarStateProvider>
      <ExhibitionKioskRedirect />
    </SidebarStateProvider>
  );
}
